
import { Component, Vue } from 'vue-property-decorator';
import { Auth } from 'aws-amplify';

@Component({})
export default class ImpersonateBar extends Vue {
  loading = false;

  get isImpersonating(): boolean {
    return this.$store.getters['auth/isImpersonating'];
  }

  get email(): string | null | undefined {
    return this.$store.getters['profile/email'];
  }

  async signOut() {
    this.loading = true;
    await Auth.signOut({ global: true });
    this.loading = false;
  }
}
